module.exports = __webpack_public_path__ + "static/media/icn_who_we_are.03929a66.svg";